'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _editRoute = require('./edit.route');

var _editRoute2 = _interopRequireDefault(_editRoute);

angular.module('BTMS').config(_editRoute2['default']);


/** WEBPACK FOOTER **
 ** ./client/private/administrators/edit/index.js
 **/